import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';

const DemoTourContext = createContext();

export const useDemoTour = () => useContext(DemoTourContext);

const STORAGE_KEY = 'autohub360_demo_tour';

export const DemoTourProvider = ({ children }) => {
  const { user } = useAuth();
  const [dismissedHints, setDismissedHints] = useState({});
  const [tourActive, setTourActive] = useState(false);

  // Load dismissed state from localStorage
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        setDismissedHints(JSON.parse(stored));
      }
    } catch {}
  }, []);

  // Auto-trigger for demo users on first visit
  useEffect(() => {
    if (user?.email === 'demo@autohub360.ca') {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        setTourActive(true);
      } else {
        try {
          const parsed = JSON.parse(stored);
          if (!parsed._tourShown) {
            setTourActive(true);
          }
        } catch {
          setTourActive(true);
        }
      }
    }
  }, [user]);

  const dismissHint = useCallback((hintId) => {
    setDismissedHints(prev => {
      const next = { ...prev, [hintId]: true };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const isHintVisible = useCallback((hintId) => {
    return tourActive && !dismissedHints[hintId];
  }, [tourActive, dismissedHints]);

  const resetTour = useCallback(() => {
    setDismissedHints({ _tourShown: true });
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ _tourShown: true }));
    setTourActive(true);
  }, []);

  const endTour = useCallback(() => {
    setTourActive(false);
    setDismissedHints(prev => {
      const next = { ...prev, _tourShown: true };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return (
    <DemoTourContext.Provider value={{ tourActive, dismissHint, isHintVisible, resetTour, endTour }}>
      {children}
    </DemoTourContext.Provider>
  );
};
